// src/components/CommentCitationSystem.js
import React, { useState, useEffect } from 'react';
import { addComment, deleteComment, subscribeToComments } from '../firebase/comments';
import CommentForm from './CommentForm';
import CitationForm from './CitationForm';
import CommentTable from './CommentTable';

const CommentCitationSystem = ({ user }) => {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('comment'); // 'comment' or 'citation'
  
  // Subscribe to comments when component mounts
  useEffect(() => {
    let unsubscribe = () => {};
    
    if (user) {
      setIsLoading(true);
      unsubscribe = subscribeToComments((commentsData) => {
        setEntries(commentsData);
        setIsLoading(false);
      });
    } else {
      setEntries([]);
      setIsLoading(false);
    }
    
    // Cleanup subscription when component unmounts
    return () => unsubscribe();
  }, [user]);
  
  const handleError = (errorMessage) => {
    setError(errorMessage);
    // Auto-dismiss error after 5 seconds
    setTimeout(() => {
      setError(null);
    }, 5000);
  };
  
  if (!user) {
    return (
      <div className="comment-citation-system">
        <div className="sign-in-prompt">
          <p>Please sign in to view and participate in discussions</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="comment-citation-system">
      {error && (
        <div className="error-banner">
          {error}
          <button 
            className="close-button" 
            onClick={() => setError(null)}
          >
            ×
          </button>
        </div>
      )}
      
      <div className="tabs">
        <button 
          className={`tab ${activeTab === 'comment' ? 'active' : ''}`}
          onClick={() => setActiveTab('comment')}
        >
          Add Comment
        </button>
        <button 
          className={`tab ${activeTab === 'citation' ? 'active' : ''}`}
          onClick={() => setActiveTab('citation')}
        >
          Add Citation
        </button>
      </div>
      
      <div className="tab-content">
        {activeTab === 'comment' ? (
          <CommentForm 
            user={user} 
            onError={handleError} 
          />
        ) : (
          <CitationForm 
            user={user} 
            onError={handleError} 
          />
        )}
      </div>
      
      <CommentTable 
        entries={entries} 
        onDeleteEntry={(entryId) => deleteComment(entryId)}
        isLoading={isLoading}
        user={user}
        onError={handleError}
      />
    </div>
  );
};

export default CommentCitationSystem;